import { makeStyles } from '@fluentui/react-components';
import { tokens } from '@bingads-webui-fluent-component/tokens';

/**
 * Fluent V2 overrides for BPBusinessListingCard.
 * Used by Account Details step.
 */
export const useV2BpCardOverrides = makeStyles({
  bpCardOverrides: {
    '& .bp-business-listing-card': {
      backgroundColor: tokens.colorNeutralBackground1,
      borderRadius: tokens.borderRadiusMedium,
    },
    '& .bp-business-listing-card-checkbox-label': {
      fontFamily: tokens.fontFamilyBase,
      fontSize: tokens.fontSizeBase300,
      color: tokens.colorNeutralForeground1,
    },
    '& .bp-business-listing-card-header': {
      fontFamily: tokens.fontFamilyBase,
      color: tokens.colorNeutralForeground1,
    },
  },
});
